import { useState } from 'react';
import Box from '@mui/material/Box';
import Assignment from '@mui/icons-material/Assignment';
import BarChartIcon from '@mui/icons-material/BarChart';

import ListIcon from '@mui/icons-material/List';
import BorderAllIcon from '@mui/icons-material/BorderAll';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SourceIcon from '@mui/icons-material/AllInboxSharp';
// import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ChainIcon from '@mui/icons-material/StoreMallDirectory'
import PeopleIcon from '@mui/icons-material/PeopleAlt';
import LockIcon from '@mui/icons-material/Lock';
import ReportOffIcon from '@mui/icons-material/ReportOff';
import FeatureIcon from '@mui/icons-material/SettingsSystemDaydream';
// import MapIcon from '@mui/icons-material/Map';

import CustomerIcon from '@mui/icons-material/Storefront'
import FolderIcon from '@mui/icons-material/Folder'
import WebAssetIcon from '@mui/icons-material/WebAsset'
import DeployIcon from '@mui/icons-material/ViewCompact'
import {
    useTranslate,
    DashboardMenuItem,
    MenuItemLink,
    useSidebarState,
    usePermissions
} from 'react-admin';

import ib_logo from 'img/ib-circle-logo.png'
import MasterCustomer from 'master_customers';
import MasterItems from 'master_items';
import CustomItemGroups from 'custom_item_groups'
import ReportParams from 'report_parameters'
import AuthorizedSuppliers from 'admin/authorized_suppliers'
import { Feature } from '../feature';

import FeatureController from './FeatureController';
import { useClientContext } from 'contexts/client';

import SubMenu from './SubMenu';
import CommitInfo from './CommitInfo';
import ApiInfo from './ApiInfo';
import { Stack } from '@mui/material';

type MenuName = 'menuSales' | 'menuReports' | 'menuMain' | 'menuAdmin' | 'menuCustomer' | 'menuItem' | 'menuFiles'| 'sourceMenu';

const Menu = ({ dense = false }: any) => {
    const [state, setState] = useState({
        menuReports: false,
        menuSales: false,
        menuMain: false,
        menuCustomer: false,
        menuItem: false,
        menuAdmin: false,
        menuFiles: false,
        sourceMenu: false,
    });
    const translate = useTranslate();
    const [open] = useSidebarState();

    const handleToggle = (menu: MenuName) => {
        setState(state => ({ ...state, [menu]: !state[menu] }));
    };
    const { permissions } = usePermissions();
    const { state: client } = useClientContext()
    const clientPrefix = client.client.resourcePrefix
    const EXTRA_MENUS = client.client.menus
    const featureList = client.client.featureList.map((feature: any) => feature.name);

    return (
        <Box
            sx={{
                width: open ? 200 : 50,
                marginTop: 1,
                marginBottom: 1,
                transition: theme =>
                    theme.transitions.create('width', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    }),
            }}
        >
            <DashboardMenuItem />
            <SubMenu
                handleToggle={() => handleToggle('menuCustomer')}
                isOpen={state.menuCustomer}
                name="portal.menu.customers"
                icon={MasterCustomer.icon}
                dense={dense}
            >
                {/* <MenuItemLink
                    to={`/${clientPrefix}_master_distributor`}
                    primaryText={'Distributor'}
                    state={{ _scrollToTop: true }}
                    leftIcon={<LocalShippingIcon />}
                    sidebarIsOpen={open}
                    dense={dense}
                /> */}
                <MenuItemLink
                    to={`/${clientPrefix}_master_chain`}
                    primaryText={'Chains'}
                    state={{ _scrollToTop: true }}
                    leftIcon={<ChainIcon />}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/${clientPrefix}_master_customers`}
                    primaryText={translate(`resources.customers.name`, {
                        smart_count: 2,
                    })}
                    state={{ _scrollToTop: true }}
                    leftIcon={<CustomerIcon />}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                {/* <MenuItemLink
                    to={`/${clientPrefix}_region`}
                    primaryText={'NACS Regions'}
                    state={{ _scrollToTop: true }}
                    leftIcon={<MapIcon />}
                    sidebarIsOpen={open}
                    dense={dense}
                /> */}
                {EXTRA_MENUS && EXTRA_MENUS['menuCustomer']
                    .filter((menuItem: any) => featureList.includes(menuItem.featureTag))
                    .map((menuItem:any, idx:number) => (
                    <MenuItemLink
                        to={menuItem.to}
                        primaryText={menuItem.label}
                        state={{ _scrollToTop: true }}
                        leftIcon={menuItem.icon}
                        sidebarIsOpen={open}
                        dense={dense}
                        key={idx}
                    />

                ))}

            </SubMenu>
            <SubMenu
                handleToggle={() => handleToggle('menuItem')}
                isOpen={state.menuItem}
                name="portal.menu.items"
                icon={<Assignment />}
                dense={dense}
            >
                <MenuItemLink
                    to={`/${clientPrefix}_master_items`}
                    primaryText={translate(`resources.items.name`, {
                        smart_count: 2,
                    })}
                    state={{ _scrollToTop: true }}
                    leftIcon={MasterItems.icon}
                    sidebarIsOpen={open}
                    dense={dense}
                />

                {EXTRA_MENUS && EXTRA_MENUS['menuItem']
                    .filter((menuItem: any) => featureList.includes(menuItem.featureTag))
                    .map((menuItem:any, idx:number) => (
                        
                        <MenuItemLink
                            to={menuItem.to}
                            primaryText={menuItem.label}
                            state={{ _scrollToTop: true }}
                            leftIcon={menuItem.icon}
                            sidebarIsOpen={open}
                            dense={dense}
                            key={idx}
                        />
                        
                        
                    ))}

                <MenuItemLink
                    to={`/${clientPrefix}_saved_item_groups`}
                    primaryText={translate(`resources.item_groups.name`, {
                        smart_count: 2,
                    })}
                    state={{ _scrollToTop: true }}
                    leftIcon={CustomItemGroups.icon}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                {(typeof permissions === 'string' && permissions.endsWith('_admin')) ? <MenuItemLink
                    to={`/${clientPrefix}_item_blacklist`}
                    primaryText={'Item Blacklist'}
                    state={{ _scrollToTop: true }}
                    leftIcon={<ReportOffIcon />}
                    sidebarIsOpen={open}
                    dense={dense}
                /> : null}
            </SubMenu>
            <SubMenu
                handleToggle={() => handleToggle('menuReports')}
                isOpen={state.menuReports}
                name="portal.menu.reports"
                icon={<BarChartIcon />}
                dense={dense}
            >
                <MenuItemLink
                    to={`/${clientPrefix}_report_parameters/create`}
                    primaryText={'Create Report'}
                    leftIcon={ReportParams.icon}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                <MenuItemLink
                    to={`/${clientPrefix}_report_parameters`}
                    primaryText={'Report History'}
                    leftIcon={<ListIcon />}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                {(permissions === 'site_admin') ?
                    <MenuItemLink
                        to={`/${clientPrefix}_report_suites`}
                        primaryText={'Report Suites'}
                        leftIcon={<ListAltIcon />}
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    : null}

                <Feature name="dashboard">
                {(permissions === 'site_admin') ?
                    <MenuItemLink
                        to={`/${clientPrefix}_dashboard_deployments`}
                        primaryText={'Dashboards'}
                        leftIcon={<DeployIcon />}
                        dense={dense}
                    />
                    : null}
                </Feature>

                <Feature name="excel">
                    {(permissions === 'site_admin') ?
                        <MenuItemLink
                            to={`/${clientPrefix}_excel_reporting`}
                            primaryText={'Excel Reporting'}
                            state={{ _scrollToTop: true }}
                            leftIcon={<BorderAllIcon />}
                            sidebarIsOpen={open}
                            dense={dense}
                        />
                        : null}
                </Feature>
                
            </SubMenu>
            {(EXTRA_MENUS && EXTRA_MENUS['menuFiles']) && (
                <SubMenu
                handleToggle={() => handleToggle('menuFiles')}
                isOpen={state.menuFiles}
                name="portal.menu.files"
                icon={<FolderIcon />}
                dense={dense}
            >

                {EXTRA_MENUS['menuFiles'].map((menuItem:any, idx:number) => (menuItem.allowedRoles.includes(permissions)) && (
                    <MenuItemLink
                        to={menuItem.to}
                        primaryText={menuItem.label}
                        leftIcon={menuItem.icon}
                        sidebarIsOpen={open}
                        dense={dense}
                        key={idx}
                    />
                ))}
            </SubMenu>
            )}

            {(EXTRA_MENUS && EXTRA_MENUS['sourceMenu']) && (
                <SubMenu
                handleToggle={() => handleToggle('sourceMenu')}
                isOpen={state.sourceMenu}
                // sidebarIsOpen={open}
                name="portal.menu.sources"
                icon={<SourceIcon/>}
                dense={dense}
            >

                {EXTRA_MENUS['sourceMenu'].map((sourceMenu:any, idx:number) => (sourceMenu.allowedRoles.includes(permissions)) && (
                    <MenuItemLink
                        to={sourceMenu.to}
                        primaryText={sourceMenu.label}
                        state={{ _scrollToTop: true }}
                        leftIcon={sourceMenu.icon}
                        sidebarIsOpen={open}
                        dense={dense}
                        key={idx}
                    />
                ))}
            </SubMenu>
            )}
            

            {(typeof permissions === 'string' && permissions.endsWith('_admin')) ?
                <SubMenu
                    handleToggle={() => handleToggle('menuAdmin')}
                    isOpen={state.menuAdmin}
                    name="portal.menu.admin"
                    icon={<LockIcon />}
                    dense={dense}
                >
                    <MenuItemLink
                        to={`/${clientPrefix}_authorized_suppliers`}
                        primaryText={'Authorized Suppliers'}
                        state={{ _scrollToTop: true }}
                        leftIcon={AuthorizedSuppliers.icon}
                        sidebarIsOpen={open}
                        dense={dense}
                    />

                    {(permissions === 'site_admin') ?
                        <MenuItemLink
                            to={`/profile`}
                            primaryText={'Site Users'}
                            state={{ _scrollToTop: true }}
                            leftIcon={<PeopleIcon />}
                            sidebarIsOpen={open}
                            dense={dense}
                        />
                        : null}

                    {(permissions === 'site_admin') ?
                        <MenuItemLink
                            to={`/${clientPrefix}_features`}
                            primaryText={'Site Features'}
                            state={{ _scrollToTop: true }}
                            leftIcon={<FeatureIcon />}
                            sidebarIsOpen={open}
                            dense={dense}
                        />
                        : null}

                    {(permissions === 'site_admin') ?
                        <MenuItemLink
                            to={`/excel_connector`}
                            primaryText={'Excel Connector'}
                            leftIcon={<WebAssetIcon />}
                            state={{ _scrollToTop: true }}
                            sidebarIsOpen={open}
                            dense={dense}
                        />
                        : null}
                </SubMenu>
                : null}

            {/* {dense } */}
            <Stack style={{
                position: 'fixed',
                bottom: '5px',
                left: '13px',
                display: 'flex',
                gap: '.5em'
            }}>
                <Box style={{ display: 'flex', flexDirection: 'row', gap: '.5em', alignItems: 'center' }}>
                    {(permissions === 'site_admin') ? 
                        <FeatureController />
                    : 
                        <img alt="InfoBate" src={ib_logo} height='33px' style={{ opacity: 0.4, filter: 'grayscale(100%)' }} />
                    }

                    {(open) ?
                        <div
                            style={{
                                fontSize: '.95rem',
                                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                fontWeight: 500,
                                lineHeight: 2.2,
                                paddingLeft: '7px',
                                letterSpacing: '0.0075em',
                                color: '#a5a2a2'
                            }}
                        >
                            InfoBate
                        </div>
                    : null}
                    {(permissions === 'site_admin') ? 
                    <small style={{ color: 'lightgrey' }}>
                        <CommitInfo />
                        <ApiInfo />
                    </small>
                : null}
                </Box>

                
            </Stack>
        </Box>
    );
};

export default Menu;